/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    maxHeight: {
      description: 'Whether MultiselectFilter modal should expand responsively to content or a set maximu height',
      type: 'state',
      values: [ true ]
    },
    maxWidth: {
      description: 'Whether MultiselectFilter modal should expand to content or a set maximuh width',
      type: 'state',
      values: [ true ]
    },
    selected: { type: 'state', values: [ true ] },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'xs' ] },
      tokens: {
        buttonDirection: 'column',
        minHeight: '100%',
        minWidth: '100%'
      }
    },
    {
      if: { maxHeight: true, viewport: [ 'sm', 'md', 'lg', 'xl' ] },
      tokens: { maxHeightSize: 480 }
    },
    {
      if: { maxWidth: true, viewport: [ 'sm', 'md', 'lg', 'xl' ] },
      tokens: { maxWidthSize: 544 }
    },
    {
      if: { selected: true },
      tokens: {
        buttonIconBackgroundColor: 'rgba(0, 0, 0, 0)',
        labelColor: '#000000'
      }
    }
  ],
  tokens: {
    buttonBackgroundColor: '#ffffff',
    buttonBackgroundColorSelected: '#ffffff',
    buttonBorderColor: '#000000',
    buttonDirection: 'row',
    buttonIconBackgroundColor: 'rgba(0, 0, 0, 0)',
    buttonIconPadding: 4,
    buttonIconSize: 20,
    containerBorderColor: '#c9c8c8',
    contentMarginBottom: 32,
    contentMarginLeft: 16,
    contentMarginRight: 16,
    contentMarginTop: 24,
    contentPaddingLeft: 16,
    contentPaddingRight: 16,
    dividerColor: '#c9c8c8',
    headerFontColor: '#000000',
    headerFontName: 'StagSans',
    headerFontSize: 14,
    headerFontWeight: '700',
    headerLineHeight: 1.33333333333,
    iconColor: '#000000',
    iconColorSelected: '#000000',
    labelColor: '#000000',
    labelFontName: 'StagSans',
    labelFontSize: 14,
    labelFontWeight: '600',
    labelLineHeight: 1.5,
    labelPaddingBottom: 8,
    labelPaddingLeft: 24,
    labelPaddingRight: 16,
    labelPaddingTop: 8,
    maxHeightSize: 480,
    maxWidthSize: 0,
    minHeight: 0,
    minWidth: 320,
    subHeaderFontName: 'StagSans',
    subHeaderFontSize: 16,
    subHeaderFontWeight: '400',
    subHeaderLineHeight: 1.5
  }
}
export default theme
